import { render, staticRenderFns } from "./modalCourseDetails.vue?vue&type=template&id=b6e5ded4&scoped=true&"
import script from "./modalCourseDetails.vue?vue&type=script&lang=js&"
export * from "./modalCourseDetails.vue?vue&type=script&lang=js&"
import style0 from "./modalCourseDetails.vue?vue&type=style&index=0&id=b6e5ded4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e5ded4",
  null
  
)

export default component.exports